import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import LoginLayoutPP from "./LoginLayoutPP";
import LoginFormPP from "./LoginFormPP";
import { containerizeLoginCmp } from "./containerizeLoginCmp";
import { intlShape, injectIntl } from "react-intl";
import { ClientLogo } from "@cxagroup/casper";
import LogoPP from "../common/LogoPP";
import { AUTH_TYPE_AUTHSERVER } from "actions/loginActions";

const STORED_RETURNURL = "ssoReturnUrl";

const DefaultLoginPagePP = props => {
  const {
    isAuthenticated,
    query: { redirectTo = "", returnUrl = "" },
    logoUrl,
    client,
    clearSystemMessage,
    loginConfig: { options = [] } = {},
    tryDetectOAuth,
  } = props;

  useEffect(() => {
    if (returnUrl) {
      sessionStorage.setItem(STORED_RETURNURL, returnUrl);
    }
    const option = options.find(opt => opt.authority === AUTH_TYPE_AUTHSERVER) || {};
    tryDetectOAuth(option.authority);
  }, [returnUrl]);

  const trySsoRedirect = () => {
    clearSystemMessage && clearSystemMessage();

    let redirectUrl = returnUrl || sessionStorage.getItem(STORED_RETURNURL);
    sessionStorage.removeItem(STORED_RETURNURL);
    if (!redirectUrl) {
      return false;
    }
    location.href = redirectUrl;
    return true;
  };

  if (isAuthenticated) {
    if (trySsoRedirect()) {
      return null;
    }
    return <Redirect to={redirectTo.length ? redirectTo : "/"} />;
  }


  return (
    <LoginLayoutPP isFlex={true}>
      <div className="login__brand" style={{ width: "100%" }}>
        {logoUrl ? (
          <ClientLogo client={client} logoUrl={logoUrl} size="large" />
        ) : (
          <LogoPP width={240} />
        )}
      </div>
      <div className="form-container">
        <LoginFormPP {...props} />
      </div>
    </LoginLayoutPP>
  );
};

DefaultLoginPagePP.propTypes = {
  isAuthenticated: PropTypes.bool,
  query: PropTypes.object,
  history: PropTypes.object,
  intl: intlShape.isRequired,
  loginConfig: PropTypes.object,
  tryDetectOAuth: PropTypes.func,
  clearSystemMessage: PropTypes.func,
  client: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
};

export default injectIntl(containerizeLoginCmp(DefaultLoginPagePP));



// WEBPACK FOOTER //
// ./components/login/DefaultLoginPagePP.jsx